// client/src/components/CartSummary.tsx
// Responsabilité unique : Affichage du résumé et total du panier

import type { CartItem } from "@/types";
import { CartCalculations } from "@/utils/cartCalculations";
import type React from "react";

interface CartSummaryProps {
  cartItems: CartItem[];
  onCheckout?: () => void;
}

/**
 * Composant de résumé du panier
 * Responsabilité unique : Affichage du total et boutons d'action
 */
const CartSummary: React.FC<CartSummaryProps> = ({ cartItems, onCheckout }) => {
  const stats = CartCalculations.getCartStats(cartItems);

  return (
    <div className="mt-6 p-4 bg-surface-2 rounded-lg border border-text/10">
      <div className="space-y-2">
        <div className="flex justify-between text-sm text-text">
          <span>Articles ({stats.totalItems})</span>
          <span>{CartCalculations.formatPrice(stats.totalAmount)}</span>
        </div>

        {stats.totalItems > 1 && (
          <div className="flex justify-between text-sm text-text/70">
            <span>Prix moyen par article</span>
            <span>{CartCalculations.formatPrice(stats.averageItemPrice)}</span>
          </div>
        )}
      </div>

      <hr className="my-4 border-text/10" />

      <div className="flex justify-between text-xl font-bold">
        <span>Total</span>
        <span>{stats.formattedTotal}</span>
      </div>

      {onCheckout && stats.totalItems > 0 && (
        <button type="button" onClick={onCheckout} className="w-full mt-4 btn btn-primary">
          Procéder au paiement
        </button>
      )}
    </div>
  );
};

export default CartSummary;
